import { render, staticRenderFns } from "./MsAndGoogleApplicationsCard.vue?vue&type=template&id=aa834a72&"
import script from "./MsAndGoogleApplicationsCard.vue?vue&type=script&lang=ts&"
export * from "./MsAndGoogleApplicationsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports